export default __webpack_public_path__ + "static/media/solar-v3.ee076530.png";